import { Product, Team } from 'teams';
import { ActionName } from 'services/observability/types';

export const generateActionName = (name: string): ActionName => ({
  name,
  teamName: Team.AI_TEAM,
  productName: Product.COPY_ASSIST,
});
